var map = {
	"./Sosyal-medya-Well-kampus-EK.jpg": 37344,
	"./well-avnt-kampus1.jpg": 47288,
	"./well-avnt-kampus2.jpg": 38246,
	"./well-avnt-kampus3.jpg": 62264,
	"./well-avnt-kampus4.jpg": 33856,
	"./well-avnt-kampus5.jpg": 64955,
	"./well-avnt-kampus6.jpg": 48572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14765;